<template>
  <b-row class="basket-item">
    <b-col lg="4" md="6" sm="12" xs="12">
      <b-img thumbnail :src="productItem.thumbnail" :alt="productItem.name"/>
    </b-col>

    <b-col lg="8" md="6" sm="12" xs="12">
      <b-row>
        <div class="name">
          <router-link class="text-decoration-none text-dark" :to="{name:'Product',params:{name:productItem.raw_link}}">
            <h4>{{ productItem.name }}</h4>
            {{ productName(item) }}
          </router-link>
        </div>
      </b-row>

      <b-row v-if="productItem.variation == 0" class="details">
        <b-col lg="6" md="6" sm="12" class="buttons">
          <plus-minus-input v-if="productItem.is_digital == 0" :qty="itemCount" :basketId="basketId"
                            :orderId="orderId"/>
          <b-btn variant="outline-danger" class="pb-2 mr-3" @click="onDelete()" value="delete">
            <b-icon icon="trash"></b-icon>
            حذف
          </b-btn>
        </b-col>

        <b-col lg="6" md="6" sm="12" class="prices">
          <small v-if="(productItem.offer > 0)"
                 class="red">
            <del>{{ formatNumber(productItem.price) }}</del>
            تومان </small>
          <p><span class="bold"> {{ formatNumber(productItem.price - productItem.offer) }} </span> تومان </p>
        </b-col>
      </b-row>
      <b-row v-if="productItem.variation == 1" class="details">
        <b-col lg="6" md="6" sm="12" class="buttons">
          <plus-minus-input v-if="productItem.is_digital == 0" :qty="itemCount" :basketId="basketId"
                            :orderId="orderId"/>
          <b-btn variant="outline-danger" class="pb-2 mr-3" @click="onDelete()" value="delete">
            <b-icon icon="trash"></b-icon>
            حذف
          </b-btn>
        </b-col>

        <b-col lg="6" md="6" sm="12" class="prices">
          <small v-if="(productPrice(item)['offer'] > 0)"
                 class="red">
            <del>{{ formatNumber(productPrice(item)['price']) }}</del>
            تومان </small>
          <p>
            <span class="bold"> {{ formatNumber(productPrice(item)['price'] - productPrice(item)['offer']) }} </span>
            تومان </p>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {productPrice, productName} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";

import PlusMinusInput from './ProductQuantity.vue'

export default {
  name: 'BasketItemRow',
  props: ['item', 'deleteFunction', 'orderId', 'basketId', 'itemCount'],
  components: {PlusMinusInput},
  data() {
    return {}
  },
  computed: {
    count() {
      return this.item.count;
    },
    productItem() {
      return this.item.product
    }
  },
  methods: {
    formatNumber,
    productPrice,
    productName,
    onDelete() {
      if (confirm('آیا از حذف این کالا از سبد خرید خود اطمینان دارید؟')) {
        let form = {'order_product_id': this.orderId.toString(), 'basket_id': this.basketId.toString()}
        this.$store.dispatch("ShoppingCart/removeItem", form)
      }
    }
  },

}
</script>

<style scoped>
.basket-item {
  padding-bottom: 40px;
  margin-top: 20px;
  margin-bottom: 20px;
  border-bottom: 2px solid lightgray;
  min-height: 200px;
}

img {
  max-height: 100%;
  float: none;
  margin-right: auto;
  margin-left: auto;
  width: 100%;
}

.name {
  position: relative;
  height: auto;
}

.details {
  position: relative;
  vertical-align: bottom;
  height: 70%;
  margin-top: auto;
  margin-bottom: 40px;
}


.buttons {
  vertical-align: bottom;
  margin-top: auto;
}

.prices {
  vertical-align: bottom;
  text-align: left;
  float: left;
  margin-top: auto;
}

.bold {
  font-weight: bolder;
  font-size: 15pt;
}
</style>